import { Gauge, UserCog, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
const features = [{
  icon: Gauge,
  title: "Access & Portability",
  description: "Request a comprehensive copy of your personal data in a structured, machine-readable format to maintain full control over your information."
}, {
  icon: UserCog,
  title: "Correction & Deletion",
  description: "Easily update inaccurate records or exercise your 'right to be forgotten' by requesting the permanent removal of your data from our systems."
}, {
  icon: Users,
  title: "Data Rights & Compliance Requests",
  description: "We adhere to strict international standards, ensuring EU visitors and global users can exercise their rights through a transparent, legal process."
}];
export default function UserRights() {
  return <section data-section-id="261789" id="user-rights" className="bg-[#0F172A] py-14 md:py-18 lg:py-20 text-[#F8FAFC] scroll-mt-[120px] h-auto flex items-center scroll-snap-align-start max-w-7xl mx-auto px-6">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-default text-[#F8FAFC] mb-6 tracking-tight leading-tight">
            Your Data Rights
          </h2>
          <p className="text-lg text-[#CBD5E1] font-sans max-w-3xl mx-auto leading-relaxed">
            FETC provides the necessary framework for users to manage and oversee their personal information in accordance with international data protection standards.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-7xl mx-auto px-6">
          {features.map((feature, i) => <div key={i} data-index={i} className="flex flex-col p-8 bg-[#142033] border border-[rgba(19,184,200,0.18)] hover:border-[#13B8C8]/40 rounded-lg transition-all duration-300 shadow-md group">
              <div className="mb-6 w-14 h-14 flex items-center justify-center bg-[#13B8C8]/10 rounded-lg text-[#13B8C8] group-hover:bg-[#13B8C8] group-hover:text-[#0B1220] transition-colors duration-300">
                <feature.icon className="w-7 h-7" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-semibold font-default text-[#F8FAFC] mb-4">
                {feature.title}
              </h3>
              <p className="text-[#CBD5E1] font-sans leading-relaxed text-sm md:text-base">
                {feature.description}
              </p>
            </div>)}
        </div>

       <div className="mt-16 md:mt-24 text-center">
  <Button asChild size="lg" className="bg-[#13B8C8] hover:bg-[#13B8C8]/90 text-[#0B1220] font-sans font-semibold text-base px-10 h-14">
    <a href="#contact-information" onClick={event => {
            event.preventDefault();
            document.getElementById("contact-information")?.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }}>
      Exercise Your Rights
    </a>
  </Button>
</div>
      </div>
    </section>;
}